import React from 'react';

const Background = () => {
    return (
        // 背景裝飾
        <div className="topbg position-absolute overflow-hidden">
            <svg
                className=" d-lg-none position-relative d-block"
                data-name="Layer2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1200 120"
                preserveAspectRatio="none"
            >
                <path
                    d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z"
                    className="shape-fill"
                ></path>
            </svg>
        </div>
        // 背景裝飾_結束
    );
};

export default Background;
